module.exports = __webpack_public_path__ + "static/6ba26953-3ec1-4ea5-b171-b366610c5de7-b34ccd5fd1eb09a41acb6ba6fe870e07.jpg";